// Checkout URLs for each plan
export const CHECKOUT_URLS = {
  esencial:
    'https://fidelate.com/products/el-costo-de-no-hacer-nada%E2%84%A2-sistema-completo-de-finanzas-personales-para-argentinos-pdf-digital',
  profesional:
    'https://fidelate.com/products/el-costo-de-no-hacer-nada%E2%84%A2-sistema-completo-de-finanzas-personales-pro?variant=58137544589686',
} as const

export type PlanKey = keyof typeof CHECKOUT_URLS
